import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d86a819"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-4" }
const _hoisted_2 = { class: "col-12 col-md-6 position-relative" }
const _hoisted_3 = { class: "col-12 col-md-6 position-relative" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "col-12 position-relative" }
const _hoisted_10 = { class: "col-12 d-flex align-items-center justify-content-end" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center justify-content-center",
  style: {"height":"200px"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Add next song?")
], -1))
const _hoisted_12 = { class: "d-flex justify-content-around w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_form, {
        modelValue: _ctx.isFormValid,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isFormValid) = $event)),
        class: "row"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_combobox, {
              modelValue: _ctx.band,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.band) = $event)),
              items: _ctx.$store.state.bands,
              ref: "bands",
              "item-title": "name",
              "auto-select-first": true,
              "item-value": "uid",
              variant: "solo",
              "custom-filter": _ctx.filter,
              "menu-props": {
                      maxHeight: 300
                    },
              rules: [
                      v => typeof v === 'object' ? true : 'Add band'
                    ],
              "return-object": true,
              label: "Band"
            }, null, 8, ["modelValue", "items", "custom-filter", "rules"]),
            (_ctx.showAddBand)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "button-add",
                  size: "small",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNewBand())),
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Add band ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_combobox, {
              modelValue: _ctx.song,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.song) = $event)),
              items: _ctx.$store.state.songs,
              ref: "songs",
              disabled: !_ctx.band.uid,
              "item-title": "name",
              "auto-select-first": true,
              "item-value": "uid",
              "custom-filter": _ctx.filter,
              variant: "solo",
              "menu-props": {
                      maxHeight: 300
                    },
              rules: [
                      v => typeof v === 'object' ? true : 'Add song'
                    ],
              "return-object": true,
              label: "Song"
            }, null, 8, ["modelValue", "items", "disabled", "custom-filter", "rules"]),
            (_ctx.showAddSong)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "button-add",
                  size: "small",
                  color: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addNewSong()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Add song ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_textarea, {
              name: "lyrics",
              variant: "solo",
              label: "Lyrics",
              "auto-grow": "",
              modelValue: _ctx.lyrics,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lyrics) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.lyricsUrl,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lyricsUrl) = $event)),
              "prepend-icon": "mdi-link-variant",
              label: "Lyrics Url",
              rules: [
              v => !v || (v && _ctx.urlRegex.test(v))  || 'URL is not valid'
            ],
              variant: "solo"
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_textarea, {
              name: "chords",
              variant: "solo",
              label: "Chrods",
              "auto-grow": "",
              modelValue: _ctx.chords,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.chords) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.tabUrl,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tabUrl) = $event)),
              "prepend-icon": "mdi-link-variant",
              label: "Tab Url",
              rules: [
              v => !v || (v && _ctx.urlRegex.test(v)) || 'URL is not valid'
            ],
              variant: "solo"
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_textarea, {
              name: "helpers",
              variant: "solo",
              label: "Helper",
              "auto-grow": "",
              modelValue: _ctx.helpers,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.helpers) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_combobox, {
              id: "categories",
              modelValue: _ctx.categories,
              "onUpdate:modelValue": [
                _cache[9] || (_cache[9] = ($event: any) => ((_ctx.categories) = $event)),
                _ctx.updateModel
              ],
              items: _ctx.$store.state.categories,
              ref: "category",
              label: "Categories",
              "item-title": "name",
              "item-value": "uid",
              "custom-filter": _ctx.filter,
              variant: "solo",
              "return-object": true,
              "menu-props": {
                      maxHeight: 300
                    },
              "onUpdate:search": _ctx.updateSearch,
              multiple: "",
              chips: ""
            }, {
              chip: _withCtx(({item}) => [
                _createVNode(_component_v_chip, {
                  style: _normalizeStyle('--category-color:' + item.raw.color || 'transparent'),
                  class: "mr-1 cursor-default category-chip elevation-2",
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.raw.name), 1)
                  ]),
                  _: 2
                }, 1032, ["style"])
              ]),
              _: 1
            }, 8, ["modelValue", "items", "custom-filter", "onUpdate:search", "onUpdate:modelValue"]),
            (_ctx.showAddCategory)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "button-add",
                  size: "small",
                  onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.addNewCategory()), ["stop"])),
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Add category ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (!this.uid)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  color: "primary",
                  disabled: !this.band || !this.song || _ctx.isFormValid === false,
                  onClick: _ctx.addMySong
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Create new song ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true),
            (this.uid)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  color: "primary",
                  disabled: !this.band || !this.song || _ctx.isFormValid === false,
                  onClick: _ctx.editMySong
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Update song ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showDialog,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showDialog) = $event)),
      persistent: "",
      width: "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_v_btn, { onClick: _ctx.goHome }, {
                    default: _withCtx(() => [
                      _createTextVNode("Go home")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    onClick: _ctx.addNext
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Add next")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}